import styled from 'vue-styled-components';

import { COLORS } from '../../colors';
import { FONTS } from '../../constants';

export const Container = styled.div`
  font-family: ${FONTS.KNOCKOUT_50_FONT};
  margin-bottom: 30px;

  svg {
    text-align: center;
    text-transform: uppercase;
    height: 60px;

    .parameter-value,
    .parameter-value path {
      outline: none;
    }

    .parameter-value text {
      transform: translate(0px, -10px);
      font-size: 1.2em;
      fill: ${COLORS.GRAY};
      font-family: ${FONTS.KNOCKOUT_50_FONT};
    }

    .tick text {
      font-size: 10px;
    }
  }
`;

export const Title = styled.div`
  color: ${COLORS.GRAY};
  margin-bottom: 5px;
  text-transform: uppercase;
  font-size: 1em;
`;

export const SliderNote = styled.div`
  text-align: center;
  font-size: 14px;
  letter-spacing: 0.2px;
  margin-top: 7px;
`;
